export const getTheme = () => {
  const hostname = window.location.hostname.toLowerCase();
  const isRoblox = hostname.includes('roblox') || window.location.port === '4000';

  if (isRoblox) {
    return {
      brandName: 'Robloxs',
      brandLogo: '🟥 Robloxs',
      colors: {
        primary: '#ef4444', // Red-500
        primaryHover: '#dc2626', // Red-600
        primaryRGB: '239, 68, 68',
        gradient: 'linear-gradient(135deg, #ef4444, #b91c1c)', // Red gradient
      }
    };
  }

  // Default / Lloop theme
  return {
    brandName: 'lloop',
    brandLogo: '/pk.png',

    colors: {
      primary: '#818cf8', // Indigo-400
      primaryHover: '#6366f1', // Indigo-500
      primaryRGB: '99, 102, 241',
      gradient: 'linear-gradient(135deg, #6366f1, #8b5cf6)', // Indigo-purple gradient
    }
  };
};
